import MomentUtils from '@date-io/moment';
import Framework, { LoadingHandler, StateErrorDisplay, shapes } from '@greenville/framework';
import {
  Box,
  Button,
  FormControlLabel,
  Grid,
  IconButton,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Typography
} from '@material-ui/core';
import { ThemeProvider, createTheme, withStyles } from '@material-ui/core/styles';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import PreviewIcon from '@mui/icons-material/Preview';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import axios from 'axios';
import _ from 'lodash';
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import Loader from '../../../../common/Loader';
import ChatgptConfig from '../../../../common/config/ChatgptConfig';
import * as constants from '../../../../common/constants';
import env from '../../../../common/env';
import utils from '../../../../common/utils';
import AutocompleteComponent from '../../common/components/Autocomplete';
import SearchButtonComponent from '../../common/components/SearchButtonComponent';
import AIChartsUtilityModel from '../../models/AIChartsUtility';
import AIContentFilterChartsModel from '../../models/AIContentFilterCharts';
import AIContentFilterChartsDetailsModel from '../../models/AIContentFilterChartsDetails';
import AIFeedbackChartsDetailsModel from '../../models/AIFeedbackChartsDetails';
import CommonSearchModel from '../../models/CommonSearchModel';
import GetBookTitlesDataModel from '../../models/GetBookTitles';
import IngestionStatusModel from '../../models/IngestionStatus';
import InternalUsersList from '../../models/InternalUsersList';
import Listing from '../../models/Listing';
import TenantConfigModel from '../../models/TenantConfig';
import Trends from '../../models/Trends';
import AdminPromptView from '../admin/AdminPromptView';
import AIChartsComponent from '../aiCharts/AIChartsComponent';
import AIContentFilterCharts from '../aiCharts/contentFilterCharts/AIContentFilterCharts';
import ChatTrendsGrid from '../datagrid/ChatTrendsGrid';
import DynamicTrendsComponent from './DynamicTrendsComponent';
import PVSIngestionComponent from './PVSIngestion/PVSIngestionComponent';
import DynamicDataGrid from './dataGrid/DynamicDataGrid';

const materialTheme = createTheme({
  palette: {
    primary: {
      light: '#047a9c',
      main: '#005d83',
      dark: '#003558',
      contrastText: '#ffffff'
    }
  },
  overrides: {
    MuiButton: {
      root: {
        borderRadius: 30
      }
    },
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: constants.PEARSON_PRIMARY_COLOR
      }
    },
    MuiPickersYear: {
      root: {
        '&:hover': {
          backgroundColor: '#d2cfc4'
        }
      },
      yearSelected: {
        color: constants.PEARSON_PRIMARY_COLOR
      },
      current: {
        color: constants.PEARSON_PRIMARY_COLOR
      }
    },
    MuiPickersDay: {
      day: {
        '&:hover': {
          backgroundColor: '#d2cfc4'
        }
      },
      daySelected: {
        backgroundColor: constants.PEARSON_PRIMARY_COLOR,
        '&:hover': {
          backgroundColor: constants.PEARSON_PRIMARY_COLOR
        }
      },
      current: {
        color: constants.PEARSON_PRIMARY_COLOR
      }
    }
  }
});

const styles = (theme) => ({
  datePicker: {
    // width: '49%',
    marginTop: 'inherit'
  },
  buttonGroupStyle: {
    justifyContent: 'center'
  },
  buttonIngestion: {
    backgroundColor: '#005d83 !important',
    color: 'white !important'
  },
  blurStyle: {
    position: 'absolute',
    background: 'rgb(255 255 255 / 20%)',
    top: '0',
    width: '93%',
    height: '100%',
    backdropFilter: 'blur(0.3px)',
    zIndex: '9999'
  },
  buttonStyle: {
    width: '120px',
    margin: '10px'
  },
  container: {
    marginBottom: 20
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'left',
    color: theme.palette.text.secondary
  },
  title: {
    marginTop: -20
  },
  labelWidht: {
    width: '380px'
  },
  boxWidth: {
    paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(4)
  },
  button: {
    paddingTop: theme.spacing(2),
    marginBottom: '-3em'
  },
  root: {
    top: '12%'
  },
  radioButton: {
    textAlign: 'center'
  },
  msgStyle: {
    fontSize: 'large',
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(0)
    },
    zIndex: 9999
  },
  headingClass: {
    padding: '15px',
    display: 'flex'
  },
  searchBarClass: {
    width: '25vw'
  },
  searchHeaders: {
    paddingLeft: '10vw'
  }
});

@inject(
  'commonSearchUtility',
  'commonSearchUtilityStatus',
  'tenantConfig',
  'bookTitles',
  'chatgptTrendsUtility',
  'chatgptListingUtility',
  'chatgptUtilityTrendsStatus',
  'ChatGptUtilityListingStatus',
  'mcqSearch',
  'aiChartsUtility',
  'aiContentfilterCharts',
  'aiContentfilterChartsDetails',
  'aiFeedbackChartsDetails',
  'AIChartsUtilityService',
  'AIContentFilterChartsService',
  'aiFeedbackChartsDetailsListService',
  'AIContentFilterChartsDetailsService',
  'internalUsers',
  'ingestionData'
)
@observer
class DynamicComponent extends React.PureComponent {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    commonSearchUtility: shapes.modelOf(CommonSearchModel).isRequired,
    commonSearchUtilityStatus: shapes.state.isRequired,
    tenantConfig: shapes.modelOf(TenantConfigModel).isRequired,
    history: PropTypes.object.isRequired,
    selectedTabValue: PropTypes.number.isRequired,
    bookTitles: shapes.modelOf(GetBookTitlesDataModel).isRequired,
    chatgptTrendsUtility: shapes.modelOf(Trends).isRequired,
    chatgptListingUtility: shapes.modelOf(Listing).isRequired,
    chatgptUtilityTrendsStatus: shapes.state.isRequired,
    ChatGptUtilityListingStatus: shapes.state.isRequired,
    aiChartsUtility: shapes.modelOf(AIChartsUtilityModel).isRequired,
    aiContentfilterCharts: shapes.modelOf(AIContentFilterChartsModel).isRequired,
    aiContentfilterChartsDetails: shapes.modelOf(AIContentFilterChartsDetailsModel).isRequired,
    aiFeedbackChartsDetails: shapes.modelOf(AIFeedbackChartsDetailsModel).isRequired,
    AIChartsUtilityService: shapes.modelOf(AIChartsUtilityModel).isRequired,
    AIContentFilterChartsService: shapes.modelOf(AIContentFilterChartsModel).isRequired,
    aiFeedbackChartsDetailsListService: shapes.modelOf(AIFeedbackChartsDetailsModel).isRequired,
    AIContentFilterChartsDetailsService: shapes.modelOf(AIContentFilterChartsDetailsModel).isRequired,
    internalUsers: shapes.modelOf(InternalUsersList).isRequired,
    ingestionData: shapes.modelOf(IngestionStatusModel).isRequired
  };

  constructor(props) {
    super(props);
    const { chatgptTrendsUtility, chatgptListingUtility, ChatGptUtilityListingStatus } = props;
    this.defaultSearch = {
      bookId: '',
      userId: '',
      email: '',
      startDateTime: '',
      endDateTime: '',
      type: '',
      startDate: '',
      endDate: '',
      manifestId: '',
      ingestionStatus: ''
    };
    this.state = {
      defaultDropdownValue: { title: constants.ALL_COURSES, bookId: constants.ALL_COURSES, id: 1 },
      isChartData: false,
      isUserIdExcluded: true,
      isSearchClicked: false,
      newRequest: true,
      searchFields: {},
      searchedDataResponse: [],
      gptResponse: chatgptTrendsUtility,
      gptListingResponse: {
        chatListDatas: chatgptListingUtility,
        chatListStatus: ChatGptUtilityListingStatus,
        loaderStatusResponse: true
      },
      setOrder: 'ASC',
      selectListingOption: false,
      selectRadioOption: false,
      setDirectionValue: '',
      ingestionDataResponse: [],
      endDisabled: true,
      loaderStatus: true,
      isbookIdRequired: false,
      bookList: [],
      inputValue: '',
      tokenValue: '',
      tenantId: '',
      tenantName: '',
      tenantTitle: '',
      showDateFields: false,
      showOutline: constants.CLUSTER_ONE_DAY_VALUE,
      toggleBtnValue: constants.TRENDS_CLUSTER,
      loadPvsIngestion: false,
      showIngestion: false,
      viewType: 'mcq',
      showCharts: {
        userFeedBackChart: false,
        blockedCountChart: false
      },
      startDateTimeError: false,
      endDateTimeError: false,
      paginationData: {
        page: 0,
        limit: 100
      },
      isBookmarkFlow: false
    };
  }

  handleIntitialValues = () => {
    this.setState({
      searchFields: { bookId: constants.ALL_COURSES },
      isbookIdRequired: false,
      inputValue: constants.ALL_COURSES
    });
  };

  componentDidMount = () => {
    const {
      commonSearchUtility,
      selectedTabValue,
      ingestionData,
      bookTitles,
      history,
      tenantConfig,
      chatgptTrendsUtility
    } = this.props;
    this.setTenantDetails();
    this.handleIntitialValues();
    /* eslint-disable camelcase */
    Framework.getEventManager().on(constants.GET_COMMON_SEARCH_UTILITY_RESPONSE, () => {
      const { newRequest, bookList, tenantName, searchedDataResponse } = this.state;
      const { data } = commonSearchUtility;
      if (commonSearchUtility && data) {
        let combineData = [];
        combineData = [...data];
        bookList?.forEach((item) => {
          const alteredValue = item.bookId;
          if (!alteredValue) return;
          combineData.forEach((dataValue, index) => {
            if (dataValue.bookId === alteredValue) {
              combineData[index].title = item.title;
            }
          });
        });
        let finalData;
        const combineDatatoJS = JSON.parse(JSON.stringify(toJS(combineData)));
        finalData = combineDatatoJS;
        if (
          selectedTabValue === ChatgptConfig.TabList.AUDIT_LOG ||
          selectedTabValue === ChatgptConfig.TabList.FEEDBACK
        ) {
          if (tenantName === 'servicenow') {
            finalData = combineDatatoJS.filter(
              (item) => ['cf426e7b1bd209508f22337f034bcbe8'].includes(item.bookId) && ['answer'].includes(item.type)
            );
          }
        }
        /* eslint-enable camelcase */
        if (newRequest) {
          const sortedDate = finalData.sort((x, y) => new Date(y.serverDateTime) - new Date(x.serverDateTime));
          this.setState({ searchedDataResponse: sortedDate, newRequest: false });
        } else {
          const combineDataGpt = [...searchedDataResponse, ...finalData];
          const sortedDate = combineDataGpt.sort((x, y) => new Date(y.serverDateTime) - new Date(x.serverDateTime));
          this.setState(() => ({ searchedDataResponse: sortedDate }));
        }
      }
    });

    Framework.getEventManager().on(constants.SET_SEARCH_INGESTION_RESPONSE, () => {
      this.setState({ loadPvsIngestion: false });
      const { data, total, page } = ingestionData;
      const resData = toJS(data);
      if (_.isEmpty(resData)) return;
      const combineDatatoJS = JSON.parse(JSON.stringify(toJS([...resData])));
      if (combineDatatoJS) {
        this.setState(() => ({
          ingestionDataResponse: combineDatatoJS,
          paginationData: {
            page,
            total
          }
        }));
      }
    });

    Framework.getEventManager().on(constants.SET_BOOK_TITLES_DATA, () => {
      const { searchFields } = this.state;
      this.setState({ loadPvsIngestion: false });
      const { data } = bookTitles;
      const bookData = toJS(data);
      if (_.isEmpty(bookData)) return;
      const shouldAddAllCourses =
        selectedTabValue === ChatgptConfig.TabList.AUDIT_LOG || selectedTabValue === ChatgptConfig.TabList.FEEDBACK;
      const selectedTenantName = history.location.pathname.split('/')[2];
      const currentTenantId = utils.getTenantId(selectedTenantName, tenantConfig);
      const bookList = shouldAddAllCourses
        ? [{ title: constants.ALL_COURSES, bookId: constants.ALL_COURSES, id: 1 }, ...bookData]
        : bookData;
      const newState = {
        bookList,
        tenantId: currentTenantId,
        ...(shouldAddAllCourses && { searchFields: { ...searchFields, bookId: constants.ALL_COURSES } })
      };

      this.setState(newState);
    });

    Framework.getEventManager().on(constants.GET_CHATGPT_TRENDS_MODEL_DATA, () => {
      const { data } = chatgptTrendsUtility;
      if (chatgptTrendsUtility) {
        const { newRequest, gptResponse, bookList } = this.state;
        const combineData = [...data];
        bookList.forEach((item) => {
          const alteredValue = item.bookId;
          if (!alteredValue) return;
          combineData.forEach((dataValue, index) => {
            if (dataValue.bookId === alteredValue) {
              combineData[index].title = item.title;
            }
          });
        });
        const combineDatatoJS = JSON.parse(JSON.stringify(toJS(combineData)));
        if (newRequest) {
          const sortedDate = combineDatatoJS.sort((x, y) => new Date(y.date) - new Date(x.date));
          this.setState({
            gptResponse: {
              ...gptResponse,
              data: sortedDate
            }
          });
        } else {
          const combineDataGpt = [...(gptResponse?.data || []), ...combineDatatoJS];
          const sortedDate = combineDataGpt.sort((x, y) => new Date(y.date) - new Date(x.date));
          this.setState((prev) => ({
            gptResponse: {
              ...gptResponse,
              data: [...(prev.gptResponse?.data || []), ...sortedDate]
            }
          }));
        }
      }
    });
    const urlParams = new URLSearchParams(window.location.search);
    const bookId = urlParams.get('bookId');
    const requestId = urlParams.get('requestId');
    const type = urlParams.get('type');

    if (bookId && requestId && type) {
      this.setState({ isBookmarkFlow: true });
    } else {
      this.setState({ isBookmarkFlow: false });
    }
    /* eslint-enable camelcase */
  };

  componentDidUpdate = (prevProps, prevState) => {
    const { selectedTabValue, tenantConfig, bookTitles } = this.props;
    const { tokenValue } = this.state;
    const { data } = toJS(tenantConfig);
    if (prevState.tokenValue !== tokenValue && (_.isEmpty(data) || (bookTitles && bookTitles.data.length === 0))) {
      this.getTenantsConfig();
    }
    if (prevProps.selectedTabValue !== selectedTabValue) {
      this.handleReset();
      this.handleIntitialValues();
    }
  };

  setTenantDetails = () => {
    const { history, tenantConfig, bookTitles } = this.props;
    const selectedTabName = history.location.pathname.split('/')[2];
    const tenantItem = ChatgptConfig.tenantData.find((item) => item.name === selectedTabName);
    if (!tenantItem) return;
    const tenantId = utils.getTenantId(tenantItem.name, tenantConfig);
    const tenantName = tenantItem.name;
    const tenantTitle = tenantItem.title;
    let bookList = bookTitles?.data?.length > 0 ? toJS(bookTitles.data) : tenantItem.titles;
    const shouldAddAllCourses = [constants.PVS, constants.DIGITALHUB, constants.REVEL].includes(tenantName);
    if (shouldAddAllCourses) {
      bookList = _.cloneDeep(bookList);
      bookList.unshift({ title: constants.ALL_COURSES, bookId: constants.ALL_COURSES, id: 1 });
    }
    this.setState({
      tenantId,
      tenantName,
      bookList,
      tenantTitle,
      ...(shouldAddAllCourses && { searchFields: { bookId: constants.ALL_COURSES } })
    });
    this.resetState();
  };

  getTenantsConfig = async () => {
    try {
      this.setState({ loadPvsIngestion: true });
      const { tokenValue } = this.state;
      const { internalUsers } = this.props;
      const usersData = JSON.parse(JSON.stringify(toJS(internalUsers)));
      const headers = {
        Authorization: `Bearer ${tokenValue}`
      };
      const response = await axios.post(
        `${env.EVERGREEN_API_BASE_URL}${constants.GET_TENANTS_CONFIG_DATA_URL}`,
        {},
        { headers }
      );
      if (response && response.data && response.data.data) {
        Framework.getStoreRegistry().getStore('tenantConfig').setResponse(response.data);
        if (usersData && usersData?.userId.length === 0) {
          this.getS3InternalUsersList();
        }
      }
    } catch (e) {
      const notification = {
        open: true,
        message: 'Error fetching tenants',
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    } finally {
      this.setState({ loadPvsIngestion: false });
    }
  };

  getBookData = async (newInputValue) => {
    const { bookTitles, history, tenantConfig } = this.props;
    const selectedTenantName = history.location.pathname.split('/')[2];
    if ([constants.PVS, constants.DIGITALHUB, constants.REVEL].includes(selectedTenantName)) {
      const currentTenantId = utils.getTenantId(selectedTenantName, tenantConfig);
      bookTitles.fetch({ tenantId: currentTenantId, newInputValue });
    }
  };

  getS3InternalUsersList = async () => {
    const { tokenValue } = this.state;
    const headers = {
      Authorization: `Bearer ${tokenValue}`
    };
    const payload = {
      itemPath: constants.S3_EXCLUDED_USERS_LIST_PATH
    };
    const response = await axios.post(`${env.EVERGREEN_API_BASE_URL}${constants.GET_S3_USERS_LIST_URL}`, payload, {
      headers
    });
    if (response && response.data && response.data.data) {
      Framework.getStoreRegistry().getStore('internalUsers').setResponse(response.data.data[0]);
    }
  };

  onInputChange = (event, newInputValue, reason) => {
    this.setState({
      inputValue: newInputValue
    });
    if (reason === 'input' && newInputValue.length >= 3 && newInputValue !== constants.ALL_COURSES) {
      this.getBookData(newInputValue);
    }
  };

  setChartData = (value) => {
    this.setState({
      isChartData: value
    });
  };

  handleChange = (e) => {
    const { searchFields } = this.state;
    const fieldChanged = {};
    fieldChanged[e.target.name] = e.target.value;
    this.setState({
      searchFields: { ...searchFields, ...fieldChanged },
      isbookIdRequired: false
    });
  };

  handleDateChange = (date, name, error) => {
    this.setState((prevState) => {
      const { searchFields } = prevState;
      const { selectedTabValue } = this.props;
      const fieldChanged = {};
      fieldChanged[name] =
        selectedTabValue === ChatgptConfig.TabList.FEEDBACK
          ? moment(date).format(constants.YYYY_MM_DD_FORMAT)
          : moment(date).format(constants.MM_DD_YYYY_FORMAT);

      const newState = {
        [error]: false,
        searchFields: { ...searchFields },
        endDisabled: false
      };

      if (date === null && fieldChanged[name] === 'Invalid date') {
        newState.searchFields[name] = '';
      } else if (fieldChanged[name] === 'Invalid date') {
        newState[error] = true;
        /* eslint-disable-next-line no-underscore-dangle */
        newState.searchFields[name] = date._i;
      } else {
        newState.searchFields[name] = fieldChanged[name];
      }

      if (name.includes('startDate') && fieldChanged[name] === 'Invalid date') {
        newState.endDisabled = true;
        newState.searchFields.endDateTime = '';
        newState.searchFields.endDate = '';
      }

      return newState;
    });
  };

  resetState = () => {
    const {
      bookTitles,
      commonSearchUtility,
      selectedTabValue,
      chatgptListingUtility,
      chatgptTrendsUtility,
      aiChartsUtility,
      aiContentfilterCharts,
      aiContentfilterChartsDetails,
      aiFeedbackChartsDetails,
      history
    } = this.props;
    const { bookList } = this.state;
    const tenantName = history.location.pathname.split('/')[2];
    commonSearchUtility.resetStoreValues();
    const newStateVal = {
      endDisabled: true,
      isbookIdRequired: false,
      searchFields: {
        ...this.defaultSearch
      },
      inputValue: '',
      showDateFields: false,
      showOutline: constants.CLUSTER_ONE_DAY_VALUE,
      toggleBtnValue: constants.TRENDS_CLUSTER,
      searchedDataResponse: [],
      ingestionDataResponse: [],
      showIngestion: false,
      startDateTimeError: false,
      endDateTimeError: false,
      showCharts: {
        userFeedBackChart: false,
        blockedCountChart: false
      },
      paginationData: {
        page: 0,
        limit: 100
      },
      newRequest: true
    };
    if ([constants.PVS, constants.DIGITALHUB, constants.REVEL].includes(tenantName)) {
      const baseList =
        (selectedTabValue === ChatgptConfig.TabList.AUDIT_LOG || selectedTabValue === ChatgptConfig.TabList.FEEDBACK) &&
        bookTitles?.data?.length > 0
          ? _.cloneDeep(toJS(bookTitles.data))
          : _.cloneDeep(bookList);
      const updatedBook = [{ title: constants.ALL_COURSES, bookId: constants.ALL_COURSES, id: 1 }, ...baseList];
      const uniqueBookList = Array.from(
        new Map(updatedBook.map((item) => [`${item.title}-${item.bookId}`, item])).values()
      );
      const updatedBookList = uniqueBookList;
      this.setState(
        selectedTabValue === ChatgptConfig.TabList.AUDIT_LOG || selectedTabValue === ChatgptConfig.TabList.FEEDBACK
          ? {
              ...newStateVal,
              bookList: updatedBookList,
              inputValue: ''
            }
          : { ...newStateVal, bookList: updatedBookList }
      );
    } else {
      this.setState(newStateVal);
    }

    chatgptListingUtility.resetStoreValues();
    chatgptTrendsUtility.resetStoreValues();
    aiChartsUtility.resetStoreValues();
    aiFeedbackChartsDetails.resetStoreValues();
    aiContentfilterCharts.resetStoreValues();
    aiContentfilterChartsDetails.resetStoreValues();
  };

  handleReset = () => {
    const { selectedTabValue } = this.props;
    const { tenantName } = this.state;
    if (
      selectedTabValue === ChatgptConfig.TabList.CONTENT_MGMT &&
      [constants.PVS, constants.DIGITALHUB, constants.REVEL].includes(tenantName)
    ) {
      this.renderContentManagementData();
    }
    this.resetState();
  };

  renderContentManagementData = async (searchPayload) => {
    const dataToSend = {
      ...searchPayload
    };
    try {
      if (dataToSend?.searchVal === constants.ALL_COURSES) {
        dataToSend.searchVal = '';
      }
      const { tokenValue } = this.state;
      const { history, tenantConfig } = this.props;
      const selectedTenantName = history.location.pathname.split('/')[2];
      const currentTenantId = utils.getTenantId(selectedTenantName, tenantConfig);
      this.setState({ loadPvsIngestion: true });
      const headers = {
        Authorization: `Bearer ${tokenValue}`,
        [constants.BERLIN_TENANT_ID_HEADER]: currentTenantId
      };
      const response = await axios.post(
        `${env.EVERGREEN_API_BASE_URL}${constants.SEARCH_PVS_INGESTION_URL}`,
        {
          searchField: dataToSend?.searchVal || '',
          page: dataToSend?.page,
          limit: dataToSend?.limit
        },
        { headers }
      );
      if (response?.data?.data?.length > 0) {
        this.setState({ loadPvsIngestion: false });
        /* eslint-disable */
        const pvsContentMgmtData = response?.data?.data?.map((item) => ({
          manifestId: item.contentPublishMessage.payload.manifestId,
          courseId: item.contentPublishMessage.payload.courseId,
          updatedAt: new Date(item.updatedAt).toLocaleString(),
          statusCode: item?.status?.code
        }));
        /* eslint-disable */
        const responseObj = {
          status: 'success',
          data: pvsContentMgmtData
        };
        this.setState({
          paginationData: {
            page: response?.data?.page,
            total: response?.data?.total
          }
        });
        Framework.getStoreRegistry().getStore('commonSearchUtility').setResponse(responseObj);
      } else {
        this.setState({ loadPvsIngestion: false });
        const notification = {
          open: true,
          message: 'No Data Found',
          type: 'error'
        };
        const responseObj = {
          status: 'success',
          data: []
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
        Framework.getStoreRegistry().getStore('commonSearchUtility').setResponse(responseObj);
      }
    } catch (e) {
      const notification = {
        open: true,
        message: e?.message || e,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
      this.setState({ loadPvsIngestion: false });
    }
  };

  handleOnSearch = (param) => {
    this.setState({
      isSearchClicked: param
    });
  };

  renderTrendsData = async (customPayload) => {
    const { searchFields, toggleBtnValue, tenantName, showOutline } = this.state;
    const { chatgptTrendsUtility, commonSearchUtility, tenantConfig, selectedTabValue } = this.props;

    if (customPayload && customPayload.lastKey) {
      this.setState({ newRequest: false });
    } else {
      this.setState({ newRequest: true });
    }
    const payload = {
      bookId: searchFields?.bookId,
      startDate: searchFields?.startDate,
      endDate: searchFields?.endDate,
      tenantId: utils.getTenantId(tenantName, tenantConfig),
      ...customPayload
    };
    let endDateChanged = new Date();
    endDateChanged = moment(endDateChanged).format(constants.YYYY_MM_DD_FORMAT);

    if ((payload && payload.startDate) || (payload && payload.bookId)) {
      if (!payload.endDate && payload.startDate) {
        payload.endDate = endDateChanged;
        this.setState({
          searchFields: { ...searchFields, endDate: endDateChanged }
        });
      }
    } else {
      payload.endDate = endDateChanged;
      payload.startDate = endDateChanged;
      this.setState({
        searchFields: { ...searchFields, startDate: endDateChanged, endDate: endDateChanged }
      });
    }
    if (toggleBtnValue === constants.TRENDS_COUNT) {
      if (payload.bookId === constants.ALL_COURSES) {
        delete payload.bookId;
      }
      chatgptTrendsUtility.fetch(payload);
    }
    if (toggleBtnValue === constants.TRENDS_CLUSTER) {
      if (_.isEmpty(searchFields?.bookId)) {
        this.setState({ isbookIdRequired: true });
      } else {
        if (showOutline === constants.CLUSTER_ONE_DAY_VALUE) {
          payload.startDate = endDateChanged;
        }
        delete payload.bookId;
        payload.toggleBtnValue = toggleBtnValue;
        payload.identifierId = searchFields?.bookId;
        payload.selectedTabValue = selectedTabValue;
        commonSearchUtility.fetch(payload);
      }
    }
    if (toggleBtnValue === constants.TRENDS_USER_FEEDBACK_COUNT) {
      this.setState({
        showCharts: {
          userFeedBackChart: true,
          blockedCountChart: false
        },
        isSearchClicked: true
      });
    }
    if (toggleBtnValue === constants.TRENDS_BLOCKED_COUNT) {
      this.setState({
        showCharts: {
          userFeedBackChart: false,
          blockedCountChart: true
        },
        isSearchClicked: true
      });
    }
  };

  fetchIngestionData = async (payload) => {
    this.setState({ loadPvsIngestion: true });
    const { ingestionData, history, tenantConfig } = this.props;
    const selectedTenantName = history.location.pathname.split('/')[2];
    const tenantId = utils.getTenantId(selectedTenantName, tenantConfig);
    const params = {
      tenantId,
      courseId: payload.bookId,
      manifestId: payload.manifestId,
      startDate: payload.startDateTime,
      endDate: payload.endDateTime,
      status: payload.ingestionStatus,
      page: payload?.paginationData?.page || 1
    };
    if (params.courseId === constants.ALL_COURSES) {
      delete params.courseId;
    }
    ingestionData.fetch(params);
  };

  fetchAllBooksData = async (payload, isNewRequest) => {
    const updatedPayload = {
      ...payload
    };
    delete updatedPayload.lastKey;
    const { newRequest } = this.state;
    const { commonSearchUtility, selectedTabValue } = this.props;
    const { summaryNextPageKey, quizNextPageKey, problemSolveNextPageKey, explainNextPageKey } = commonSearchUtility;
    const isFeedbackCall = selectedTabValue === ChatgptConfig.TabList.FEEDBACK;
    const dataToSend = {
      ...Object.fromEntries(
        Object.entries(updatedPayload).filter(([key, value]) => key !== 'bookId' && value !== null && value !== '')
      )
    };
    if (!dataToSend.startDateTime) {
      dataToSend.startDateTime = utils.getStartDate24HoursAgo();
    }
    const removeEmptyKeys = (objKeys) => {
      let lastKey = {};
      if (objKeys && objKeys.ExclusiveStartKey) {
        const startKey = objKeys.ExclusiveStartKey;
        /* eslint-disable no-param-reassign */
        lastKey = Object.entries(startKey).reduce((obj, [key, value]) => {
          if (key !== null && value !== null) {
            obj[key] = value;
          }
          return obj;
        }, {});
      }
      return { ExclusiveStartKey: lastKey };
    };
    const explainTypeLastKey = explainNextPageKey?.ExclusiveStartKey?.bookId?.S
      ? { lastKey: removeEmptyKeys(explainNextPageKey) }
      : {};
    const summaryTypeLastKey = summaryNextPageKey?.ExclusiveStartKey?.bookId?.S
      ? { lastKey: removeEmptyKeys(summaryNextPageKey) }
      : {};
    const problemSolveTypeLastKey = problemSolveNextPageKey?.ExclusiveStartKey?.bookId?.S
      ? { lastKey: removeEmptyKeys(problemSolveNextPageKey) }
      : {};
    const quizMcqTypeLastKey = quizNextPageKey?.ExclusiveStartKey?.bookId?.S
      ? { lastKey: removeEmptyKeys(quizNextPageKey) }
      : {};
    const apiPayloadOne = {
      ...dataToSend,
      type: isFeedbackCall ? constants.FEEDBACK_EXPLAIN_TYPE : constants.EXPLAIN_TYPE,
      ...explainTypeLastKey
    };
    const apiPayloadTwo = {
      ...dataToSend,
      type: isFeedbackCall ? constants.FEEDBACK_QUIZ_TYPE : constants.QUIZ_MCQ_TYPE,
      ...quizMcqTypeLastKey
    };
    const apiPayloadThree = {
      ...dataToSend,
      type: constants.PROBLEM_SOLVE,
      ...problemSolveTypeLastKey
    };
    const apiPayloadFour = {
      ...dataToSend,
      type: constants.SUMMARY_TYPE,
      ...summaryTypeLastKey
    };

    if (newRequest || isNewRequest || apiPayloadOne?.lastKey) {
      commonSearchUtility.fetch(apiPayloadOne);
    }
    if (newRequest || isNewRequest || apiPayloadTwo?.lastKey) {
      commonSearchUtility.fetch(apiPayloadTwo);
    }
    if (newRequest || isNewRequest || apiPayloadThree?.lastKey) {
      commonSearchUtility.fetch(apiPayloadThree);
    }
    if (newRequest || isNewRequest || apiPayloadFour?.lastKey) {
      commonSearchUtility.fetch(apiPayloadFour);
    }
  };

  handleSearch = async (customPayload) => {
    const {
      searchFields,
      tenantId,
      tenantName,
      showIngestion,
      startDateTimeError,
      endDateTimeError,
      newRequest,
      auditAndFeedback
    } = this.state;
    const { commonSearchUtility, selectedTabValue, tenantConfig } = this.props;
    if (newRequest) {
      commonSearchUtility.resetStoreValues();
    }
    let tenatIdVal = tenantId;
    if (_.isEmpty(tenantId)) {
      tenatIdVal = utils.getTenantId(tenantName, tenantConfig);
    }
    if (startDateTimeError || endDateTimeError) return;

    const bookSearch = { allBookSearch: false };
    const isNewRequest = !(customPayload && customPayload.lastKey);

    if (isNewRequest) {
      if (searchFields?.bookId === constants.ALL_COURSES) {
        commonSearchUtility.resetPageNextKey();
      }
      this.setState({ newRequest: true });
    } else {
      this.setState({ newRequest: false });
    }

    const payload = { ...searchFields, ...customPayload };
    const endDateChanged = moment(new Date()).format(constants.YYYY_MM_DD_FORMAT);
    const isTrendsTab =
      selectedTabValue === ChatgptConfig.TabList.TRENDS &&
      ![constants.AI_STUDY_TOOLS, constants.CHANNELS].includes(tenantName);
    const isContentManagementTab =
      selectedTabValue === ChatgptConfig.TabList.CONTENT_MGMT &&
      [constants.RPLUS, constants.PVS, constants.ACTIVEHUB, constants.DIGITALHUB, constants.REVEL].includes(
        tenantName
      ) &&
      !showIngestion;
    const hasSearchInput =
      payload.bookId ||
      payload.email ||
      payload.userId ||
      payload.type ||
      payload.manifestId ||
      payload.ingestionStatus ||
      showIngestion;

    if (isTrendsTab) {
      this.renderTrendsData(customPayload);
      return;
    }

    if (isContentManagementTab) {
      const searchVal = payload.manifestId || payload.bookId;
      const searchPayload = {
        searchVal,
        page: payload?.paginationData?.page,
        limit: payload?.paginationData?.limit
      };
      this.renderContentManagementData(searchPayload);
      return;
    }

    if (!hasSearchInput) {
      if (selectedTabValue !== ChatgptConfig.TabList.PROMPT) {
        this.setState({ isbookIdRequired: true });
      }
      return;
    }

    Object.assign(payload, {
      tenantId: tenatIdVal,
      tenantName,
      selectedTabValue
    });

    const isIngestionTab =
      selectedTabValue === ChatgptConfig.TabList.CONTENT_MGMT &&
      [constants.PVS, constants.DIGITALHUB, constants.REVEL].includes(tenantName) &&
      showIngestion;
    const isAllCoursesSearch =
      (selectedTabValue === ChatgptConfig.TabList.AUDIT_LOG || selectedTabValue === ChatgptConfig.TabList.FEEDBACK) &&
      [constants.PVS, constants.DIGITALHUB, constants.REVEL].includes(tenantName) &&
      payload.bookId === constants.ALL_COURSES &&
      !payload.type &&
      !payload.email &&
      !payload.userId;

    if (isIngestionTab) {
      if (!payload.endDateTime && payload.startDateTime) {
        payload.endDateTime = endDateChanged;
        this.setState({
          searchFields: { ...searchFields, endDateTime: endDateChanged }
        });
      }
      this.fetchIngestionData(payload);
      return;
    }

    if (isAllCoursesSearch) {
      bookSearch.allBookSearch = true;
      commonSearchUtility.setAllBookSearch(bookSearch);
      this.fetchAllBooksData(payload, isNewRequest);
      return;
    }
    commonSearchUtility.resetPageNextKey();
    bookSearch.allBookSearch = false;
    commonSearchUtility.setAllBookSearch(bookSearch);

    if (payload.bookId === constants.ALL_COURSES) {
      const { bookId, ...searchPayload } = payload;
      commonSearchUtility.fetch(searchPayload);
    } else if (
      selectedTabValue !== ChatgptConfig.TabList.AUDIT_LOG ||
      selectedTabValue !== ChatgptConfig.TabList.FEEDBACK
    ) {
      commonSearchUtility.fetch(payload);
    }
  };

  handleAscendingTrends = (dir, value) => {
    const { gptResponse } = this.state;
    if (dir === 'asc') {
      const sorted = [...gptResponse?.data].sort((a, b) => (a[value] > b[value] ? 1 : -1));
      this.setState({
        gptResponse: {
          ...gptResponse,
          data: sorted
        }
      });
    } else {
      const sorted = [...gptResponse?.data].sort((a, b) => (a[value] < b[value] ? 1 : -1));
      this.setState({
        gptResponse: {
          ...gptResponse,
          data: sorted
        }
      });
    }
  };

  sorting = (value) => {
    const { setOrder } = this.state;
    if (setOrder === 'ASC') {
      this.handleAscendingTrends('asc', value);
      this.setState({
        setOrder: 'DSC',
        setDirectionValue: value
      });
    }
    if (setOrder === 'DSC') {
      this.handleAscendingTrends('des', value);
      this.setState({
        setOrder: 'ASC',
        setDirectionValue: value
      });
    }
  };

  handleAscending = (dir, value) => {
    const { searchedDataResponse } = this.state;
    if (dir === 'asc') {
      const sorted = [...searchedDataResponse].sort((a, b) =>
        a[value] && b[value] && a[value].toLowerCase() > b[value].toLowerCase() ? 1 : -1
      );
      this.setState({
        ...searchedDataResponse,
        searchedDataResponse: sorted
      });
    } else {
      const sorted = [...searchedDataResponse].sort((a, b) =>
        a[value] && b[value] && a[value].toLowerCase() < b[value].toLowerCase() ? 1 : -1
      );
      this.setState({
        ...searchedDataResponse,
        searchedDataResponse: sorted
      });
    }
  };

  onAutoCompleteChange = (event, newValue) => {
    const { searchFields } = this.state;
    this.setState({
      searchFields: {
        ...searchFields,
        bookId: newValue !== null ? newValue.bookId : ''
      },
      isbookIdRequired: false
    });
  };

  handleSelectChange = (e) => {
    const { commonSearchUtility } = this.props;
    this.setState({
      toggleBtnValue: e.target.value,
      selectRadioOption: e.target.value,
      searchedDataResponse: [],
      newRequest: true
    });
    const {
      chatgptListingUtility,
      chatgptTrendsUtility,
      aiChartsUtility,
      aiContentfilterCharts,
      aiContentfilterChartsDetails,
      aiFeedbackChartsDetails
    } = this.props;
    chatgptListingUtility.resetStoreValues();
    chatgptTrendsUtility.resetStoreValues();
    aiChartsUtility.resetStoreValues();
    aiFeedbackChartsDetails.resetStoreValues();
    aiContentfilterCharts.resetStoreValues();
    aiContentfilterChartsDetails.resetStoreValues();
    // commonSearchUtility.resetStoreValues();
  };

  handleDateclicker = (event, value) => {
    const { searchFields } = this.state;
    const daysvalue = event.target.innerText;
    let startDate = new Date();
    let endDate = new Date();
    switch (daysvalue) {
      case '1d':
        this.setState({
          showOutline: value,
          showDateFields: false
        });
        break;
      case '3d':
        startDate.setDate(startDate.getDate() - 2);
        this.setState({
          showOutline: value,
          showDateFields: false
        });
        break;
      case '1w':
        startDate.setDate(startDate.getDate() - 6);
        this.setState({
          showOutline: value,
          showDateFields: false
        });
        break;
      default:
    }
    startDate = moment(startDate).format(constants.YYYY_MM_DD_FORMAT);
    endDate = moment(endDate).format(constants.YYYY_MM_DD_FORMAT);
    this.setState({
      searchFields: { ...searchFields, startDate, endDate }
    });
  };

  trendsDataFetch = (value) => {
    const { showDateFields } = this.state;
    if (value === 'custom') {
      this.setState({
        showOutline: value,
        showDateFields: !showDateFields
      });
    }
  };

  handleFilterUserChange = (e) => {
    this.setState({
      isUserIdExcluded: e.target.checked
    });
  };
  setAutocompleteLable = () => {
    const { tenantName } = this.state;
    let lableVal = 'Book Id';
    if (tenantName === 'servicenow') {
      lableVal = 'Knowledge Based Group';
    }
    if ([constants.PVS, constants.DIGITALHUB, constants.REVEL].includes(tenantName)) {
      lableVal = 'Course Title';
    }
    return lableVal;
  };

  handleIngestionClick = () => {
    this.setState({ showIngestion: true });
  };

  handleBackClick = () => {
    this.setState({ showIngestion: false });
    this.handleReset();
  };

  handleViewTypeChange = (e) => {
    this.setState({
      ...this.state,
      viewType: e.target.value
    });
  };

  renderAuditFeedback = () => {
    const { classes, selectedTabValue, history } = this.props;
    const {
      searchFields,
      endDisabled,
      bookList,
      isbookIdRequired,
      inputValue,
      tenantName,
      startDateTimeError,
      endDateTimeError,
      isUserIdExcluded,
      defaultDropdownValue
    } = this.state;

    const pathSegment = history.location.pathname.split('/')[2];
    const identifiers = [pathSegment, tenantName];
    const isMatch =
      identifiers.includes(constants.PVS) ||
      identifiers.includes(constants.DIGITALHUB) ||
      identifiers.includes(constants.REVEL);
    const updatedTypes = [...ChatgptConfig.filterByChats, ...ChatgptConfig.agentTypes];

    return (
      <>
        <Grid container direction="row">
          <Grid item xs={1} />
          <Grid item xs={10}>
            <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'space-between', p: '0px 33px' }}>
              <FormControl sx={{ minWidth: '32%', maxWidth: '90%' }} size="small">
                <AutocompleteComponent
                  options={bookList}
                  onAutoCompleteChange={this.onAutoCompleteChange}
                  onInputChange={this.onInputChange}
                  stateVal={inputValue}
                  errorVal={isbookIdRequired}
                  name="bookId"
                  label={this.setAutocompleteLable()}
                  componentDefaultValue={isMatch ? defaultDropdownValue : undefined}
                />
                {isbookIdRequired && (
                  <FormHelperText style={{ color: 'red' }}>
                    Please select any {this.setAutocompleteLable()}
                  </FormHelperText>
                )}
              </FormControl>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <ThemeProvider theme={materialTheme}>
                  <KeyboardDatePicker
                    className={classes.datePicker}
                    format={constants.MM_DD_YYYY_FORMAT}
                    autoOk
                    size="small"
                    variant="inline"
                    style={{ minWidth: '32%' }}
                    inputVariant="outlined"
                    disableFuture
                    value={searchFields.startDateTime || null}
                    label="Start Date"
                    onChange={(date) => this.handleDateChange(date, 'startDateTime', 'startDateTimeError')}
                    KeyboardButtonProps={{
                      'aria-label': 'change date'
                    }}
                    helperText={startDateTimeError ? 'Invalid Date Format' : ''}
                    error={startDateTimeError}
                  />
                  <KeyboardDatePicker
                    className={classes.datePicker}
                    format={constants.MM_DD_YYYY_FORMAT}
                    autoOk
                    variant="inline"
                    size="small"
                    style={{ minWidth: '32%' }}
                    inputVariant="outlined"
                    disableFuture
                    value={searchFields.endDateTime || null}
                    label="End Date"
                    minDate={searchFields.startDateTime || undefined}
                    onChange={(date) => this.handleDateChange(date, 'endDateTime', 'endDateTimeError')}
                    disabled={endDisabled}
                    KeyboardButtonProps={{
                      'aria-label': 'change date'
                    }}
                    helperText={endDateTimeError ? 'Invalid Date Format' : ''}
                    error={endDateTimeError}
                  />
                </ThemeProvider>
              </MuiPickersUtilsProvider>
            </Box>
          </Grid>
          <Grid item xs={1} />
        </Grid>
        <br />
        <Grid container direction="row">
          <Grid item xs={1} />
          <Grid item xs={10} direction="row">
            <Box sx={{ display: 'flex', justifyContent: 'space-between', p: '0px 32px' }}>
              <TextField
                label="User ID"
                margin="dense"
                name="userId"
                onChange={(event) => this.handleChange(event)}
                style={{ minWidth: '32%' }}
                value={searchFields.userId}
                variant="outlined"
              />
              <TextField
                label="Email ID"
                margin="dense"
                type="email"
                style={{ minWidth: '32%' }}
                name="email"
                onChange={(event) => this.handleChange(event)}
                value={searchFields.email}
                variant="outlined"
              />
              <FormControl sx={{ mt: 1, width: '32%' }} size="small">
                <InputLabel id="demo-simple-select-autowidth-label">Type</InputLabel>
                <Select
                  label="Type"
                  name="type"
                  onChange={(event) => this.handleChange(event)}
                  value={searchFields.type || ''}
                >
                  <MenuItem disabled value="">
                    <em>{constants.SELECT_PLACEHOLDER_TYPE}</em>
                  </MenuItem>
                  {tenantName === 'servicenow' ? (
                    <MenuItem value="answer">Explain</MenuItem>
                  ) : selectedTabValue === ChatgptConfig.TabList.AUDIT_LOG ? (
                    ChatgptConfig.filterByChats.map((value, index) => (
                      <MenuItem divider={index === 3} value={value.name}>
                        {value.label}
                      </MenuItem>
                    ))
                  ) : (
                    selectedTabValue === ChatgptConfig.TabList.FEEDBACK &&
                    ChatgptConfig.feedBackTypesDropdownList.map((value) => (
                      <MenuItem value={value.name}>{value.label}</MenuItem>
                    ))
                  )}
                </Select>
              </FormControl>
            </Box>
          </Grid>
          <Grid item xs={1} />
        </Grid>
        <Box>
          <Grid container direction="row" justifyContent="center">
            <FormControl size="small">
              <FormControlLabel
                control={
                  <Checkbox onChange={this.handleFilterUserChange} name="excludeUserId" checked={isUserIdExcluded} />
                }
                style={{
                  alignItems: 'center'
                }}
                labelPlacement="end"
                label="Filter Internal Users"
              />
            </FormControl>
          </Grid>
        </Box>
        <br />
      </>
    );
  };

  renderContentMangementScreen = () => {
    const { classes } = this.props;
    const { searchFields, viewType, bookList, inputValue } = this.state;
    return (
      <>
        <Box display="flex" style={{ justifyContent: 'flex-end', marginRight: '30px' }}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<PreviewIcon />}
            onClick={this.handleIngestionClick}
            className={classes.buttonIngestion}
          >
            Ingestion
          </Button>
        </Box>
        <Box display="flex" style={{ justifyContent: 'center' }}>
          <Grid container direction="row" alignItems="center">
            <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'end' }}>
              <FormControl sx={{ minWidth: '32%', maxWidth: '90%' }} size="small">
                <AutocompleteComponent
                  options={bookList}
                  onAutoCompleteChange={this.onAutoCompleteChange}
                  onInputChange={this.onInputChange}
                  stateVal={inputValue}
                  name="bookId"
                  label={this.setAutocompleteLable()}
                />
              </FormControl>
              <Typography variant="inherit" align="center" gutterBottom spacing={9} style={{ padding: '10px' }}>
                OR
              </Typography>
              <TextField
                label="Manifest ID"
                margin="dense"
                name="manifestId"
                onChange={(event) => this.handleChange(event)}
                style={{ minWidth: '32%', marginTop: '2px' }}
                value={searchFields.manifestId}
                variant="outlined"
              />
            </Box>
          </Grid>
          <Grid item xs={6} alignItems="center" className={classes.headingClass}>
            <ThemeProvider theme={materialTheme}>
              <Box sx={{ minWidth: 120 }}>
                <FormControl fullWidth>
                  <RadioGroup
                    name="viewType"
                    value={viewType}
                    onChange={this.handleViewTypeChange}
                    style={{
                      display: 'flex',
                      flexDirection: 'row'
                    }}
                  >
                    <FormControlLabel value="mcq" control={<Radio color="primary" />} label="Quiz" />
                    <FormControlLabel value="summary" control={<Radio color="primary" />} label="Summary" />
                  </RadioGroup>
                </FormControl>
              </Box>
            </ThemeProvider>
          </Grid>
        </Box>
      </>
    );
  };

  renderIngestionScreen = () => {
    const { classes } = this.props;
    const { searchFields, inputValue, bookList, endDisabled, startDateTimeError, endDateTimeError } = this.state;
    return (
      <>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <IconButton onClick={this.handleBackClick}>
            <ArrowBackIosIcon />
          </IconButton>
        </Box>
        <Grid container direction="row">
          <Grid item xs={1} />
          <Grid item xs={10}>
            <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'space-between', p: '0px 33px' }}>
              <FormControl sx={{ minWidth: '32%', maxWidth: '90%' }} size="small">
                <AutocompleteComponent
                  options={bookList}
                  onAutoCompleteChange={this.onAutoCompleteChange}
                  onInputChange={this.onInputChange}
                  stateVal={inputValue}
                  name="bookId"
                  label={this.setAutocompleteLable()}
                />
              </FormControl>
              <TextField
                label="Manifest ID"
                margin="dense"
                name="manifestId"
                onChange={(event) => this.handleChange(event)}
                style={{ minWidth: '32%', marginTop: '2px' }}
                value={searchFields.manifestId}
                variant="outlined"
              />
              <FormControl sx={{ width: '32%' }} size="small">
                <InputLabel id="ingestionStatus">Ingestion Status</InputLabel>
                <Select
                  label="Ingestion Status"
                  name="ingestionStatus"
                  onChange={(event) => this.handleChange(event)}
                  value={searchFields.ingestionStatus || ''}
                >
                  <MenuItem disabled value="">
                    <em>{constants.SELECT_PLACEHOLDER_INGESTION}</em>
                  </MenuItem>
                  <MenuItem value="Received">Received</MenuItem>
                  <MenuItem value="InProgress">InProgress</MenuItem>
                  <MenuItem value="Completed">Completed</MenuItem>
                  <MenuItem value="CompletedWithErrors">CompletedWithErrors</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Grid>
          <Grid item xs={1} />
        </Grid>
        <br />
        <Grid container direction="row">
          <Grid item xs={1} />
          <Grid item xs={10} direction="row">
            <Box sx={{ display: 'flex', justifyContent: 'center', p: '0px 32px' }}>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <ThemeProvider theme={materialTheme}>
                  <KeyboardDatePicker
                    className={classes.datePicker}
                    format={constants.MM_DD_YYYY_FORMAT}
                    autoOk
                    size="small"
                    variant="inline"
                    style={{ minWidth: '32%', marginRight: '15px' }}
                    inputVariant="outlined"
                    disableFuture
                    value={searchFields.startDateTime || null}
                    label="Start Date"
                    onChange={(date) => this.handleDateChange(date, 'startDateTime', 'startDateTimeError')}
                    KeyboardButtonProps={{
                      'aria-label': 'change date'
                    }}
                    helperText={startDateTimeError ? 'Invalid Date Format' : ''}
                    error={startDateTimeError}
                  />
                  <KeyboardDatePicker
                    className={classes.datePicker}
                    format={constants.MM_DD_YYYY_FORMAT}
                    autoOk
                    variant="inline"
                    size="small"
                    style={{ minWidth: '32%' }}
                    inputVariant="outlined"
                    disableFuture
                    value={searchFields.endDateTime || null}
                    label="End Date"
                    minDate={searchFields.startDateTime || undefined}
                    onChange={(date) => this.handleDateChange(date, 'endDateTime', 'endDateTimeError')}
                    disabled={endDisabled}
                    KeyboardButtonProps={{
                      'aria-label': 'change date'
                    }}
                    helperText={endDateTimeError ? 'Invalid Date Format' : ''}
                    error={endDateTimeError}
                  />
                </ThemeProvider>
              </MuiPickersUtilsProvider>
            </Box>
          </Grid>
          <Grid item xs={1} />
        </Grid>
        <br />
      </>
    );
  };

  render() {
    const {
      classes,
      commonSearchUtilityStatus,
      chatgptUtilityTrendsStatus,
      AIChartsUtilityService,
      AIContentFilterChartsDetailsService,
      aiFeedbackChartsDetailsListService,
      AIContentFilterChartsService,
      selectedTabValue,
      commonSearchUtility: {
        isNextPageKey,
        summaryNextPageKey,
        quizNextPageKey,
        problemSolveNextPageKey,
        explainNextPageKey
      },
      history,
      tenantConfig
    } = this.props;
    const {
      searchFields,
      endDisabled,
      searchedDataResponse,
      ingestionDataResponse,
      loaderStatus,
      bookList,
      isbookIdRequired,
      inputValue,
      tokenValue,
      showDateFields,
      toggleBtnValue,
      showOutline,
      tenantName,
      tenantTitle,
      loadPvsIngestion,
      tenantId,
      showIngestion,
      viewType,
      isUserIdExcluded,
      isSearchClicked,
      showCharts,
      isChartData,
      setOrder,
      selectRadioOption,
      selectListingOption,
      setDirectionValue,
      gptListingResponse,
      gptResponse,
      startDateTimeError,
      endDateTimeError,
      paginationData,
      isBookmarkFlow
    } = this.state;

    const activeSession = utils.getSessionData();
    if (activeSession !== null && tokenValue === '') {
      const token = utils.getToken();
      this.setState({
        tokenValue: token
      });
    }

    const isNextPageKeyEnable = {};
    isNextPageKeyEnable.ExclusiveStartKey = {
      bookId:
        summaryNextPageKey?.ExclusiveStartKey?.bookId?.S ||
        quizNextPageKey?.ExclusiveStartKey?.bookId?.S ||
        problemSolveNextPageKey?.ExclusiveStartKey?.bookId?.S ||
        explainNextPageKey?.ExclusiveStartKey?.bookId?.S
    };
    return (
      <>
        {[
          constants.PVS,
          constants.PACEBLUEPRINT,
          constants.RPLUS,
          constants.ACTIVEHUB,
          constants.DIGITALHUB,
          constants.REVEL
        ].includes(tenantName) && history.location.pathname.split('/')[3] === 'promptmgt' ? (
          <AdminPromptView />
        ) : (
          <>
            <Paper>
              <Box sx={{ flexGrow: 1 }}>
                <Box sx={{ p: 2 }}>
                  <Typography variant="h5" align="center" gutterBottom spacing={9}>
                    {constants.CHAT_CRITERIA_TEXT}
                  </Typography>
                </Box>
                {selectedTabValue === ChatgptConfig.TabList.TRENDS ? (
                  <DynamicTrendsComponent
                    showDateFields={showDateFields}
                    searchFields={searchFields}
                    endDisabled={endDisabled}
                    showOutline={showOutline}
                    toggleBtnValue={toggleBtnValue}
                    bookList={bookList}
                    inputValue={inputValue}
                    handleSelectChange={this.handleSelectChange}
                    trendsDataFetch={this.trendsDataFetch}
                    handleDateclicker={this.handleDateclicker}
                    onInputChange={this.onInputChange}
                    onAutoCompleteChange={this.onAutoCompleteChange}
                    handleDateChange={this.handleDateChange}
                    tenantName={tenantName}
                    isUserIdExcluded={isUserIdExcluded}
                    handleFilterUserChange={this.handleFilterUserChange}
                    isbookIdRequired={isbookIdRequired}
                    startDateTimeError={startDateTimeError}
                    endDateTimeError={endDateTimeError}
                    handleIntitialValues={this.handleIntitialValues}
                  />
                ) : (
                  <>
                    {history.location.pathname.split('/')[3] !== 'titlesearch' ? (
                      this.renderAuditFeedback()
                    ) : (
                      <>{!showIngestion ? this.renderContentMangementScreen() : this.renderIngestionScreen()}</>
                    )}
                  </>
                )}
              </Box>
              <SearchButtonComponent
                classes={classes}
                handleSearch={this.handleSearch}
                handleReset={this.handleReset}
              />
            </Paper>
            <LoadingHandler
              loading={
                chatgptUtilityTrendsStatus.isPending ||
                commonSearchUtilityStatus.isPending ||
                AIChartsUtilityService.isPending ||
                aiFeedbackChartsDetailsListService.isPending ||
                AIContentFilterChartsDetailsService.isPending ||
                AIContentFilterChartsService.isPending ||
                loadPvsIngestion
              }
              isError={
                chatgptUtilityTrendsStatus.isError &&
                commonSearchUtilityStatus.isError &&
                commonSearchUtilityStatus.error &&
                commonSearchUtilityStatus.error.status === 401 &&
                commonSearchUtilityStatus.error.status === 500
              }
              content={
                (searchedDataResponse && searchedDataResponse.length > 0) ||
                isBookmarkFlow ||
                (ingestionDataResponse && ingestionDataResponse.length > 0) ? (
                  <Box>
                    <br />
                    {history.location.pathname.split('/')[3] === 'titlesearch' && showIngestion ? (
                      <>
                        <PVSIngestionComponent
                          data={ingestionDataResponse}
                          paginationData={paginationData}
                          handleSearch={this.handleSearch}
                        />
                        <br />
                      </>
                    ) : (
                      <DynamicDataGrid
                        selectedTab={selectedTabValue}
                        gridData={searchedDataResponse}
                        handleSearch={this.handleSearch}
                        handleAscending={this.handleAscending}
                        isNextPageKey={isNextPageKey}
                        toggleBtnValue={toggleBtnValue}
                        tenantName={tenantName}
                        tenantTitle={tenantTitle}
                        tenantId={tenantId}
                        viewType={viewType}
                        startDate={searchFields.startDate || ''}
                        endDate={searchFields.endDate || ''}
                        tenantConfig={tenantConfig}
                        isUserIdExcluded={isUserIdExcluded}
                        isNextPageKeyEnable={isNextPageKeyEnable}
                        paginationData={paginationData}
                        showIngestion={showIngestion}
                        searchFields={searchFields}
                      />
                    )}
                  </Box>
                ) : (gptResponse && gptResponse?.data?.length > 0) ||
                  (gptListingResponse.chatListDatas.data && gptListingResponse.chatListDatas.data.length > 0) ? (
                  <Box>
                    <br />
                    <ChatTrendsGrid
                      chatgptUtilityTrendsData={toJS(gptResponse?.data)}
                      chatgptUtilityListingData={gptListingResponse}
                      sorting={this.sorting}
                      setOrder={setOrder}
                      setDirectionValue={setDirectionValue}
                      selectRadioOption={selectRadioOption}
                      selectListingOption={selectListingOption}
                      startDate={searchFields.startDate || ''}
                      endDate={searchFields.endDate || ''}
                      isUserIdExcluded={isUserIdExcluded}
                      tenantId={utils.getTenantId(constants.PVS, tenantConfig)}
                      tenantName={tenantName}
                    />
                  </Box>
                ) : (
                  !isChartData && (
                    <>
                      <br />
                      <Paper>
                        <br />
                        <Box>
                          <br />
                          <Typography
                            variant="h4"
                            align="center"
                            gutterBottom
                            spacing={9}
                            className={classes.title}
                            style={{ p: 5, mt: 25 }}
                          >
                            {constants.CHAT_FETCH}
                          </Typography>
                        </Box>
                      </Paper>
                    </>
                  )
                )
              }
              loadingContent={<Loader loaderStatus={loaderStatus} />}
              errorContent={<StateErrorDisplay error={commonSearchUtilityStatus.error} showDetails />}
            />
            {showCharts.userFeedBackChart && (
              <>
                <br />
                <AIChartsComponent
                  searchFields={searchFields}
                  handleOnSearch={this.handleOnSearch}
                  isSearchClicked={isSearchClicked}
                  isUserIdExcluded={isUserIdExcluded}
                  tenantName={tenantName}
                  setChartData={this.setChartData}
                />
              </>
            )}

            {showCharts.blockedCountChart && (
              <>
                <br />
                <AIContentFilterCharts
                  searchFields={searchFields}
                  handleOnSearch={this.handleOnSearch}
                  isSearchClicked={isSearchClicked}
                  bookList={bookList}
                  isUserIdExcluded={isUserIdExcluded}
                  tenantName={tenantName}
                  setChartData={this.setChartData}
                />
              </>
            )}
          </>
        )}
      </>
    );
  }
}

export default withStyles(styles)(DynamicComponent);
